"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreviewClipStencil = exports.previewClipStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.previewClipStencilDefinition = {
    view: {
        label: 'Preview clip',
        titleItems: ['title'],
        imageItems: ['clip-essence'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'title',
                    'teaser',
                    'clip-essence',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: ['uri-title', 'geolocation'],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
    },
    content: {
        [properties_1.clipEssencePropertyDefinition.name]: properties_1.clipEssencePropertyDefinition,
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.geolocationPropertyDefinition.name]: properties_1.geolocationPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: properties_1.standalonePropertyDefinition,
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: properties_1.teaserPropertyDefinition,
        [properties_1.titlePropertyDefinition.name]: {
            ...properties_1.titlePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'maxLength',
                    argument: 75,
                },
            ],
        },
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
    },
    localizations: ['en'],
    roles: [],
    spaces: [
        'alinghi',
        'batalla',
        'brand-building-events',
        'global',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull_com',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
    ],
    name: 'preview-clip',
};
const isPreviewClipStencil = (stencil) => {
    return stencil.name === exports.previewClipStencilDefinition.name;
};
exports.isPreviewClipStencil = isPreviewClipStencil;
//# sourceMappingURL=data:application/json;base64,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